import TextInput from './textInput'
import FileInput from './fileInput'
import Textarea from './textarea'
import SliderInput from './sliderInput'

export { TextInput, FileInput, Textarea, SliderInput }
